import {
  createBrowserRouter,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgotPassword from "../pages/auth/forgot-password";
import AuthRoutes from "./auth.routes";
import Main from "../pages/main";
import Appointments from "../pages/appointments";
import Profile from "../pages/profile";
import Details from "../pages/appointments/details";
import Reschedule from "../pages/appointments/reschedule";
import Cancel from "../pages/appointments/cancel";
import Transactions from "../pages/transactions";
import VoiceMeeting from "../pages/chime/voice-meeting";
import VideoMeeting from "../pages/chime/video-meeting";
import Chat from "../pages/chime/chat";
import SetUpAccount from "../pages/auth/set-up-account";
import DoctorReport from "../pages/appointments/doctor-report";
import NotFound from "../pages/not-found";
import Availability from "../pages/availability";
import EPrescription from "../pages/E-prescription";
import Createxrayreport from "../pages/E-prescription/x-ray";
import Createlabrequest from "../pages/E-prescription/labrequest";
import Createeprescription from "../pages/E-prescription/create-eprescription";
import EPrescriptionDetail from "../pages/E-prescription/detail";
import DiagnosticDetail from "../pages/E-prescription/diagnostic-detail";
import { E_PRESCRIPTIONS_BASE } from "../constants/e-prescriptions";

function RedirectEprescriptionHub() {
  const { search } = useLocation();
  return <Navigate to={`${E_PRESCRIPTIONS_BASE}${search}`} replace />;
}

function RedirectEprescriptionDiagnostic() {
  const { id } = useParams<{ id: string }>();
  return (
    <Navigate to={`${E_PRESCRIPTIONS_BASE}/diagnostic/${id}`} replace />
  );
}

function RedirectEprescriptionDetail() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`${E_PRESCRIPTIONS_BASE}/${id}`} replace />;
}

export const router = createBrowserRouter([
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/sign-in",
    element: <Login />,
  },
  {
    path: "/sign-up",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    element: <AuthRoutes />,
    children: [
      {
        path: "/set-up",
        element: <SetUpAccount />,
      },
      {
        path: "/:id/voice-call",
        element: <VoiceMeeting />,
      },
      {
        path: "/:id/video-meeting",
        element: <VideoMeeting />,
      },
      {
        path: "/",
        element: <Main />,
        children: [
          {
            element: <Appointments />,
            index: true,
          },
          {
            path: "/appointments/:id",
            element: <Details />,
          },
          {
            path: "/appointments/:id/report",
            element: <DoctorReport />,
          },
          {
            path: "/appointments/reschedule/:id",
            element: <Reschedule />,
          },
          {
            path: "/appointments/cancel/:id",
            element: <Cancel />,
          },
          {
            path: "/appointments/chat",
            element: <Chat />,
          },
          {
            path: "/schedule",
            element: <Availability />,
          },
          {
            path: "/transactions",
            element: <Transactions />,
          },
          {
            path: E_PRESCRIPTIONS_BASE,
            element: <EPrescription />,
          },
          {
            path: `${E_PRESCRIPTIONS_BASE}/xray`,
            element: <Createxrayreport />,
          },
          {
            path: `${E_PRESCRIPTIONS_BASE}/labrequest`,
            element: <Createlabrequest />,
          },
          {
            path: `${E_PRESCRIPTIONS_BASE}/new`,
            element: <Createeprescription />,
          },
          {
            path: `${E_PRESCRIPTIONS_BASE}/diagnostic/:id`,
            element: <DiagnosticDetail />,
          },
          {
            path: `${E_PRESCRIPTIONS_BASE}/:id`,
            element: <EPrescriptionDetail />,
          },
          {
            path: "/eprescription",
            element: <RedirectEprescriptionHub />,
          },
          {
            path: "/eprescription/xray",
            element: <Navigate to={`${E_PRESCRIPTIONS_BASE}/xray`} replace />,
          },
          {
            path: "/eprescription/labrequest",
            element: <Navigate to={`${E_PRESCRIPTIONS_BASE}/labrequest`} replace />,
          },
          {
            path: "/eprescription/new",
            element: <Navigate to={`${E_PRESCRIPTIONS_BASE}/new`} replace />,
          },
          {
            path: "/eprescription/diagnostic/:id",
            element: <RedirectEprescriptionDiagnostic />,
          },
          {
            path: "/eprescription/:id",
            element: <RedirectEprescriptionDetail />,
          },
          {
            path: "/profile/:id",
            element: <Profile />,
          },
        ],
      },
    ],
  },
]);
